import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function fileSizeValidator(bytes: number): ValidatorFn {

    return (control: AbstractControl): FileSizeValidation | null => {
        if (control.value === null ) {
            return null;
        }
        const file = control.value as File;
        if (file && file.size > bytes) {
            return { fileSize: true };
        }

        return null;
    };
}

export interface FileSizeValidation extends ValidationErrors {
    fileSize: boolean;
}

